import React, { useEffect, useState, useRef } from 'react'
import Preloader from '../components/Preloader'
import PageHeader from '../components/PageHeader'
import HeroCarousel from '../components/HeroCarousel'
import TourCategories from '../components/TourCategories'
import GhanaRegions from '../components/GhanaRegions'
import Subscribe from '../components/Subscribe'
import Footer from '../components/Footer'
import ScrollReveal from '../components/ScrollReveal'
import styles from '../styles/autoslider.module.css';
import { Helmet } from 'react-helmet';

const Index = () => {

    // partner slider
    // At the top of your Home component:
    const sliderRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);

    const slides = [
        { src: "../assets/newvrifylogowithbgcolor.jpg", alt: "partner logo" },
        { src: "../assets/89devswhitelogo.jpg", alt: "partner logo" },
        { src: "../assets/pendulummedia.jpg", alt: "partner logo" },
        { src: "../assets/newvrifylogowithbgcolor.jpg", alt: "partner logo" },
        { src: "../assets/89devswhitelogo.jpg", alt: "partner logo" },
        { src: "../assets/pendulummedia.jpg", alt: "partner logo" },
        { src: "../assets/newvrifylogowithbgcolor.jpg", alt: "partner logo" },
        { src: "../assets/89devswhitelogo.jpg", alt: "partner logo" },
        { src: "../assets/pendulummedia.jpg", alt: "partner logo" },
        { src: "../assets/newvrifylogowithbgcolor.jpg", alt: "partner logo" },
        { src: "../assets/89devswhitelogo.jpg", alt: "partner logo" },
        { src: "../assets/pendulummedia.jpg", alt: "partner logo" },
        // ...add all your slides here...
    ];

    // Duplicate slides for seamless looping
    const loopSlides = [...slides, ...slides, ...slides, ...slides, ...slides, ...slides,];

    // Manual drag handlers (mouse/touch)
    function handleMouseDown(e) {
        setIsDragging(true);
        setStartX(e.pageX - sliderRef.current.offsetLeft);
        setScrollLeft(sliderRef.current.scrollLeft);
    }
    function handleMouseLeave() {
        setIsDragging(false);
    }
    function handleMouseUp() {
        setIsDragging(false);
    }
    function handleMouseMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 1.5;
        sliderRef.current.scrollLeft = scrollLeft - walk;
    }
    function handleTouchStart(e) {
        setIsDragging(true);
        setStartX(e.touches[0].pageX - sliderRef.current.offsetLeft);
        setScrollLeft(sliderRef.current.scrollLeft);
    }
    function handleTouchEnd() {
        setIsDragging(false);
    }
    function handleTouchMove(e) {
        if (!isDragging) return;
        const x = e.touches[0].pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX) * 1.5;
        sliderRef.current.scrollLeft = scrollLeft - walk;
    }

    // Set initial scroll position to the middle set for seamless looping
    useEffect(() => {
        if (sliderRef.current) {
            const slideWidth = 250 + 30; // 250px width + 2*15px padding
            sliderRef.current.scrollLeft = slides.length * slideWidth;
        }
    }, [slides.length]);

    // Infinite loop logic on scroll
    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;
        const slideWidth = 250 + 30;
        const totalSlides = slides.length;
        const totalLoopSlides = loopSlides.length;

        const handleScroll = () => {
            const maxScroll = slideWidth * (totalLoopSlides - totalSlides);
            if (slider.scrollLeft <= 0) {
                // Jump forward to the same slide in the middle set
                slider.scrollLeft = slideWidth * totalSlides;
            } else if (slider.scrollLeft >= maxScroll) {
                // Jump back to the same slide in the middle set
                slider.scrollLeft = slideWidth * totalSlides;
            }
            // Update current index for indicators/buttons
            const idx = Math.round(slider.scrollLeft / slideWidth) % totalSlides;
            setCurrentIndex(idx);
        };
        slider.addEventListener("scroll", handleScroll);
        return () => slider.removeEventListener("scroll", handleScroll);
    }, [slides.length, loopSlides.length]);
    // Scroll to a specific slide (in the middle set)
    const scrollToSlide = (idx) => {
        if (!sliderRef.current) return;
        const slideWidth = 250 + 30;
        sliderRef.current.scrollTo({
            left: (slides.length + idx) * slideWidth,
            behavior: "smooth",
        });
    };

    // Next/Prev button handlers (looping)
    const goToPrev = () => {
        scrollToSlide((currentIndex - 1 + slides.length) % slides.length);
    };
    const goToNext = () => {
        scrollToSlide((currentIndex + 1) % slides.length);
    };

    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <Helmet>
                <title>Home | VRIFY Africa</title>
                <meta name="description" content="Welcome to VRIFY Africa. Experience immersive virtual tours and digital solutions across Ghana and Africa." />
                <meta name="keywords" content="Virtual Tours, Ghana, Africa, Real Estate, Tourism, VRIFY Tours" />
            </Helmet>
            <PageHeader />
            <Preloader />
            <HeroCarousel />
            <main>
                <TourCategories />
                <GhanaRegions />
                {/* Our Partners Section */}
                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                    <div className="py-2 px-4 text-center container mx-auto">
                        <h2 className="text-4xl font-semibold text-gray-800 font-cormorant-upright mb-2">Our Partners</h2>
                        <hr className="w-8 border-2 border-black rounded-md mx-auto mb-4" />
                    </div>
                </ScrollReveal>
                <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={400}>
                    <div className={styles.container + " w-full px-2 sm:px-4 md:px-8 lg:px-16 xl:px-32"} style={{ position: "relative" }}>
                        <div className={styles.row} style={{ position: "relative" }}>
                            {/* Prev Button */}
                            <button
                                onClick={goToPrev}
                                aria-label="Previous"
                                className="absolute left-0 top-1/2 z-10 -translate-y-1/2 bg-green-400 hover:bg-green-700 text-white rounded-full w-10 h-10 flex items-center justify-center shadow transition-all duration-200"
                                style={{ opacity: 0.85 }}
                            >
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <div
                                className={styles.firstsliding}
                                ref={sliderRef}
                                style={{ cursor: isDragging ? "grabbing" : "grab", position: "relative" }}
                                onMouseDown={handleMouseDown}
                                onMouseLeave={handleMouseLeave}
                                onMouseUp={handleMouseUp}
                                onMouseMove={handleMouseMove}
                                onTouchStart={handleTouchStart}
                                onTouchEnd={handleTouchEnd}
                                onTouchMove={handleTouchMove}
                                tabIndex={0}
                            >
                                <div className={styles.firstslidetrack} style={{ width: `calc(250px * ${loopSlides.length})` }}>
                                    {loopSlides.map((slide, idx) => (
                                        <div className={styles.firstslide} key={idx}>
                                            <img src={slide.src} alt={slide.alt} loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* Next Button */}
                            <button
                                onClick={goToNext}
                                aria-label="Next"
                                className="absolute right-0 top-1/2 z-10 -translate-y-1/2 bg-green-400 hover:bg-green-700 text-white rounded-full w-10 h-10 flex items-center justify-center shadow transition-all duration-200"
                                style={{ opacity: 0.85 }}
                            >
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </ScrollReveal>
                {/* Subscribe Section */}
                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={600}>
                    <Subscribe />
                </ScrollReveal>
                {/* Other page content can go here */}
            </main>
            <Footer />
        </div>
    )
}

export default Index